import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

interface IStepperProgressProps {
    progress: number; // Progress in percents
    active: boolean;
}

export const StepperContainer = styled.section`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
`;

export const StepperHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-family: Calibre;
    font-size: 16px;
    color: ${Variables.Colors.n70};
`;

export const StepperProgressActive = styled.div<IStepperProgressProps>`
    padding: 5px 0;
    transform: translateY(-5px);
    box-sizing: content-box;
    background-clip: content-box;

    width: ${(props): string => props.progress + '%'};
    height: 100%;
    background-color: ${({ active }) => (active ? Variables.Colors.b300 : Variables.Colors.n15)};
    cursor: pointer;

    &:hover {
        height: 13px;
        padding: 0;
        transform: translateY(-5px);
    }
`;

export const StepperProgress = styled.div`
    height: 3px;
    width: 100%;
    background-color: ${Variables.Colors.nx8};
    position: relative;
    margin-top: 8px;
    display: flex;

    ${StepperProgressActive} {
        &:first-of-type {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        &:last-of-type {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
`;
